import { isNative } from "@stepapp/core";
import { Block, Button, Divider, Typography, palette, useBreakpoints } from "@stepapp/ui";
import { useRouter } from "expo-router";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

const AlreadyHaveAccount = () => {
  const { t } = useTranslation();
  const { sm } = useBreakpoints();

  const { navigate, back } = useRouter();

  const handleNavigate = useCallback(() => {
    if (isNative) {
      back();
      setTimeout(() => navigate("/login/phone"), 500);
    } else {
      navigate("/login/phone");
    }
  }, [navigate, back]);

  return (
    <>
      {isNative && <Divider spaceless color={palette.secondary.grey} />}
      <Block
        marginTop={isNative ? 2 : 1.5}
        marginBottom={3}
        justifyCenter={sm}
        marginLeft={sm ? 0 : 0.5}
        alignCenter
        row
      >
        <Typography variant="body">{t("screens.auth.alreadyHaveAccount")} </Typography>
        <Button label={t("screens.auth.logIn")} onPress={handleNavigate} type={"link"} />
      </Block>
    </>
  );
};

export default React.memo(AlreadyHaveAccount);
